import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { fiGetLocaleCode, IAvailableDateTimeFormat } from '@fi-shared/utils';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import * as moment from 'moment';

export const FI_FORMATS = {
    parse: {
        dateInput: { month: 'numeric', year: 'numeric', day: 'numeric' },
    },
    display: {
        //dateInput: { month: 'numeric', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: 'input',
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@Injectable()
export class FiDateAdapter extends NativeDateAdapter {
    userPreferredDateFormat: IAvailableDateTimeFormat;
    customFormat: string | null = null;

    constructor(
        private fiFormatDateService: FiFormatDateService,
        private fiUserDataService: FiUserDataService,
    ) {
        super(fiGetLocaleCode(fiUserDataService.applicationLanguage));
        this.userPreferredDateFormat = fiFormatDateService.getUserPreferredDateFormat();
    }

    setCustomFormat(format: string | null): void {
        this.customFormat = format;
    }

    parse(value: any): Date {
        // If customFormat is set, use it for validation and parsing
        if (this.customFormat && typeof value === 'string' && value) {
            const m = moment(value, this.customFormat, true);
            if (m.isValid()) {
                return m.toDate();
            } else {
                return new Date(NaN);
            }
        }
        // Fallback to default validation and parsing
        // dont parse too short dates
        if (typeof value === typeof '' && value) {
            const res: boolean = this.userPreferredDateFormat.validationRegExp.test(value);
            if (!res) return new Date(NaN);
        }
        const parseDate: Date = value ? moment(value + ' 00:00', this.userPreferredDateFormat.label).toDate() : value;
        return super.parse(parseDate);
    }

    format(date: Date, displayFormat: Object): string {
        if (this.customFormat && displayFormat == 'input') {
            return moment(date).format(this.customFormat);
        }
        return displayFormat == 'input'
            ? this.fiFormatDateService.formatDate(date, this.userPreferredDateFormat.options)
            : super.format(date, displayFormat);
    }

    getFirstDayOfWeek(): number {
        return 1; // first columns should be monday
    }

    isValid(date: Date): boolean {
        return super.isValid(date);
    }

    private _to2digit(n: number): string {
        return ('00' + n).slice(-2);
    }
}
